import { lazy, Suspense } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import ProtectedRoute from "@/shared/components/routes/ProtectedRoute";
import PublicRoute from "@/shared/components/routes/PublicRoute";
import { RouteLoadingFallback } from "@/shared/components/RouteLoadingFallback";
import { authStorageService } from "@/modules/auth/services/authStorageService";

const Home = lazy(() => import("../pages/Home"));
const Auth = lazy(() => import("../pages/Auth"));
const Dashboard = lazy(() => import("../pages/Dashboard"));
const ProjectPage = lazy(() => import("../pages/ProjectPage"));

function App() {
  return (
    <Router>
      <Suspense fallback={<RouteLoadingFallback />}>
      <Routes>
        {/* Public routes - only accessible when NOT authenticated */}
        <Route
          path="/"
          element={
            <PublicRoute>
              <Home />
            </PublicRoute>
          }
        />

        {/* Auth page route */}
        <Route
          path="/auth"
          element={
            <PublicRoute>
              <Auth />
            </PublicRoute>
          }
        />
        {/* Protected Routes */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/c/:id"
          element={
            <ProtectedRoute>
              <ProjectPage />
            </ProtectedRoute>
          }
        />

        {/* Redirect unknown routes based on auth status */}
        <Route path="*" element={<RouteRedirect />} />
      </Routes>
      </Suspense>
    </Router>
  );
}

function RouteRedirect() {
  const isAuthenticated = authStorageService.isAuthenticated();
  return isAuthenticated ? (
    <Navigate to="/dashboard" replace />
  ) : (
    <Navigate to="/" replace />
  );
}

export default App;
